<template>
  <v-row dense>
    <v-col class="mx-n3">
      <div id="chart" class="mt-14">
        <apexchart
          type="area"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { apexchart: VueApexCharts },
  props: {
    dataAtendidas: Array,
    dataNaoAtendidas: Array,
    dataCategories: Object,
  },
  data: () => ({
    series: [
      {
        name: "Atendidas",
        data: [],
      },
      {
        name: "Não Atendidas",
        data: [],
      },
    ],
    chartOptions: {
      colors: ["#66BB6A", "#EF5350"],
      title: {
        text: "Ligações por Dia",
        align: "left",
        style: {
          fontFamily: "Roboto_700Bold",
          fontSize: "24px",
        },
      },
      chart: {
        height: 250,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        type: "category",
        categories: [],
      },
      yaxis: {
        labels: {
          formatter: function(val) {
            return Number(val).toFixed(0);
          },
        },
      },
    },
  }),

  watch: {
    dataAtendidas: {
      deep: true,
      immediate: true,
      handler() {
        this.series[0].data = [...this.dataAtendidas];
        this.series.splice(0, 1, this.series[0]);
      },
    },

    dataNaoAtendidas: {
      deep: true,
      immediate: true,
      handler() {
        this.series[1].data = [...this.dataNaoAtendidas];
        this.series.splice(0, 1, this.series[0]);
      },
    },

    dataCategories: {
      deep: true,
      immediate: true,
      handler() {
        const valoresXaxis = [...this.dataCategories.dataCategory];

        this.chartOptions = {
          colors: ["#66BB6A", "#EF5350"],
          title: {
            text: this.dataCategories.title,
            align: "left",
            style: {
              // fontFamily: 'Roboto_700Bold',
              fontFamily: "sans-serif",
              fontWeight: "bold",
              fontSize: "23px",
              color: "darkenGray",
            },
          },
          chart: {
            height: 250,
            type: "area",
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          xaxis: {
            type: "category",
            categories: valoresXaxis,
          },
          yaxis: {
            labels: {
              formatter: function(val) {
                return Number(val).toFixed(0);
              },
            },
          },
        };
      },
    },
  },
};
</script>
